import { create } from "zustand";

const useTribePostStore = create((set, get) => ({
  refetchPost: false,

  setRefetchPost: () => set({ refetchPost: !get().refetchPost }),
}));

export default useTribePostStore;
